const RECORD_TOKEN_KEY = 'record_admin_token'

export const getToken = () => {
  return window.localStorage.getItem(RECORD_TOKEN_KEY)
};

export const saveToken = token => {
  window.localStorage.setItem(RECORD_TOKEN_KEY, token)
};

export const destroyToken = () => {
  window.localStorage.removeItem(RECORD_TOKEN_KEY)
};

export const saveInfo = (KEY, VAL) => {
  window.localStorage.setItem(KEY, VAL)
};

export const getInfo = KEY => {
  return window.localStorage.getItem(KEY)
};


export default { getToken, saveToken, destroyToken, saveInfo, getInfo }



// WEBPACK FOOTER //
// ./src/common/jwt.service.js